import { ISchedulePeriod, IScheduleUnit } from '../../data-rules-model';
import { ScheduleRate } from './schedule-data.service';

const scheduleUnits: IScheduleUnit[] = [
  {
    unit: 'Minutes',
    value: 'MINUTES'
  },
  {
    unit: 'Hour(s)',
    value: 'HOURS'
  },
  {
    unit: 'Day(s)',
    value: 'DAYS'
  }
];

const schedulePeriods: ISchedulePeriod[] = [
  // Minutes
  {
    value: 5,
    idUnit: 'MINUTES'
  },
  {
    value: 15,
    idUnit: 'MINUTES'
  },
  {
    value: 30,
    idUnit: 'MINUTES'
  },
  // Hours
  {
    value: 1,
    idUnit: 'HOURS'
  },
  {
    value: 2,
    idUnit: 'HOURS'
  },
  {
    value: 4,
    idUnit: 'HOURS'
  },
  {
    value: 8,
    idUnit: 'HOURS'
  },
  {
    value: 12,
    idUnit: 'HOURS'
  },
  //  Days
  {
    value: 1,
    idUnit: 'DAYS'
  },
  {
    value: 2,
    idUnit: 'DAYS'
  },
  {
    value: 3,
    idUnit: 'DAYS'
  },
  {
    value: 4,
    idUnit: 'DAYS'
  },
  {
    value: 5,
    idUnit: 'DAYS'
  },
  {
    value: 6,
    idUnit: 'DAYS'
  },
  {
    value: 7,
    idUnit: 'DAYS'
  },
  {
    value: 14,
    idUnit: 'DAYS'
  },
  {
    value: 21,
    idUnit: 'DAYS'
  },
  {
    value: 28,
    idUnit: 'DAYS'
  },
  {
    value: 35,
    idUnit: 'DAYS'
  }
];

export class ScheduleService {

  static getUnits(): IScheduleUnit[] {
    return scheduleUnits;
  }

  static getPeriods(): ISchedulePeriod[] {
    return schedulePeriods;
  }

  static getScheduledRuleId(scheduledRuleName: string): string {
    return scheduledRuleName.substring(scheduledRuleName.length - 36, scheduledRuleName.length);
  }

  static getScheduleRate(ruleExpression: string): ScheduleRate {

    let unit = ruleExpression.substring(ruleExpression.indexOf(' ') + 1, ruleExpression.indexOf(')')).toUpperCase();
    const period = parseInt(ruleExpression.substring(ruleExpression.indexOf('(') + 1, ruleExpression.indexOf(' ')), 10);

    if (unit === 'DAY') {
      unit = 'DAYS';
    }

    if (unit === 'HOUR') {
      unit = 'HOURS';
    }

    return [unit, period];
  }

}
